import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { blue } from '@mui/material/colors';
import WarningIcon from '@mui/icons-material/WarningOutlined';
import ChatIcon from '@mui/icons-material/Chat';

const StyledTable = styled(Table)(() => ({
  '& .MuiTableCell-root': {
    border: '1px solid #D7D7DD',
    paddingTop: 5,
    paddingBottom: 5,
    lineHeight: 1,
  },
  '.MuiTableRow-head': {
    backgroundColor: '#F4FEEC',
  },
}));

export default function InspectionTable(props) {
  const { rows, title } = props;

  const newRows = rows.map(
    ({ id, name, grey, green, yellow, red, fixed, comments }) => {
      return {
        id,
        name,
        grey,
        green,
        yellow,
        red,
        fixed,
        comments,
      };
    }
  );

  return (
    <StyledTable>
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: '30%' }} align="left" colSpan={2}>
            <span className="text-sm font-semibold text-black">{title}</span>
          </TableCell>
          <TableCell sx={{ width: '5%' }} align="center" colSpan={1}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <span className="text-xs text-black">Passed</span>
              <CheckCircleIcon sx={{ color: 'success.main', mt: 2 }} />
            </Box>
          </TableCell>
          <TableCell sx={{ width: '5%' }} align="center" colSpan={1}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <span className="text-xs text-black">Fixed / Replaced</span>
              <CheckCircleIcon sx={{ color: blue[800], mt: 2 }} />
            </Box>
          </TableCell>
          <TableCell sx={{ width: '5%' }} align="center" colSpan={1}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <span className="text-12 text-black">Needs Attention</span>
              <WarningIcon sx={{ color: 'warning.main', mt: 2 }} />
            </Box>
          </TableCell>
          <TableCell sx={{ width: '5%' }} align="center" colSpan={1}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <span className="text-12 text-black">Needs Work</span>
              <WarningIcon sx={{ color: 'error.main', mt: 2 }} />
            </Box>
          </TableCell>
          <TableCell sx={{ width: '25%' }} align="center" colSpan={1}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <span className="text-12 text-black">Comments</span>
              <ChatIcon sx={{ mt: 2 }} />
            </Box>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {newRows.map((row, index) => (
          <TableRow key={row.id}>
            <TableCell component="th" scope="row">
              <span className="text-black">{index + 1}</span>
            </TableCell>
            <TableCell align="left">
              <span className="text-12 text-black">{row.name}</span>
            </TableCell>
            <TableCell align="center">
              {row.green ? (
                <div className="flex justify-center items-center">
                  <CheckCircleIcon sx={{ color: 'success.main' }} />
                </div>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell align="center">
              {row.fixed ? (
                <div className="flex justify-center items-center">
                  <CheckCircleIcon sx={{ color: blue[800] }} />
                </div>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell align="center">
              {row.yellow ? (
                <div className="flex justify-center">
                  <WarningIcon sx={{ color: 'warning.main' }} />
                </div>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell align="center">
              {row.red ? (
                <div className="flex justify-center">
                  <WarningIcon sx={{ color: 'error.main' }} />
                </div>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell align="center" colSpan={1}>
              {row.comments ? (
                <div className="flex justify-center flex-col">
                  {row?.comments?.map((comment, index) => (
                    <div
                      className="flex-col flex justify-start items-start"
                      key={index}
                    >
                      <span className="text-justify">{comment ?? ''}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <></>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
}
